import { ISelfServeBrandOrder } from "@faire/web-api--source/indigofair/helpcenter/ISelfServeBrandOrder";
import isEmpty from "lodash/isEmpty";

export const orderIsFreeDutiesEligible = (brandOrder: ISelfServeBrandOrder) => {
  const { free_duties_reason } = brandOrder;
  return !isEmpty(free_duties_reason);
};
